import {
  convertWorkSizeToString,
  getDefaultSizeData,
  SizeData,
  WorkImportCandidateData,
} from '../../shared/dto/EntityRepository';
import { DimensionsType } from '../../shared/enum/EnumRepository';

const normalizeCandidateSize = (
  candidate: WorkImportCandidateData,
): SizeData => {
  const size = candidate.size;
  const fallback = getDefaultSizeData();

  return {
    unit: size?.unit ?? fallback.unit,
    width: size?.width == null ? '' : String(size.width),
    height: size?.height == null ? '' : String(size.height),
    depth: size?.depth == null ? undefined : String(size.depth),
    dpi: size?.dpi == null ? undefined : String(size.dpi),
  };
};

export const getCandidateSize = (candidate: WorkImportCandidateData): string =>
  convertWorkSizeToString(
    normalizeCandidateSize(candidate),
    candidate.dimensionsType ?? DimensionsType.FIXED,
    candidate.sizeText,
    'Variable',
  );
